import { AccessError } from '@/types/errors';

interface ErrorConfig {
  message: React.ReactNode;
  showRecheckSession: boolean;
}

export const getErrorConfig = (error: AccessError): ErrorConfig => {
  switch (error) {
    case AccessError.NO_ACCESS:
      return {
        message:
          'You do not have access to this service with your current selected channel. Please select a different channel and refresh or logout.',
        showRecheckSession: true,
      };
    case AccessError.COULD_NOT_VALIDATE:
      return {
        message: 'Could not validate your access.',
        showRecheckSession: true,
      };
    default:
      return {
        message: 'An unknown error occurred.',
        showRecheckSession: false,
      };
  }
};
